document.addEventListener("DOMContentLoaded", async () => {
    const appEl = document.getElementById("giftletter-view-app");
    if (!appEl) return;

    const { db, getQueryParam, replaceSlackEmojiShortcodes } = window.GiftLetterFirebase;

    const giftId = getQueryParam("gid");
    const token = getQueryParam("token");
    const POSTMARK_IMAGE_URL = "https://jiyucho.tokyo/cdn/shop/files/kesihinImage.png?v=1773991973&width=500";

    const titleIconUrl = appEl.dataset.titleIcon || "";

    function escapeHtml(str = "") {
        return String(str)
        .replaceAll("&", "&amp;")
        .replaceAll("<", "&lt;")
        .replaceAll(">", "&gt;")
        .replaceAll('"', "&quot;")
        .replaceAll("'", "&#039;");
    }

    function preloadImage(src) {
        return new Promise((resolve) => {
            if (!src) return resolve();
            const img = new Image();
            img.onload = () => resolve(src);
            img.onerror = () => resolve(src);
            img.src = src;
        });
    }

    function loadImageMeta(src) {
        return new Promise((resolve) => {
            if (!src) return resolve(null);

            const img = new Image();
            img.onload = () => {
            resolve({
                src,
                width: img.naturalWidth,
                height: img.naturalHeight
            });
            };
            img.onerror = () => resolve(null);
            img.src = src;
        });
    }

    function bindEntryToggles(root) {
        const cards = root.querySelectorAll("[data-entry-toggle]");

        cards.forEach((card) => {
            const message = card.querySelector(".giftletter-view-message");
            if (!message) return;

            const lineHeight = parseFloat(window.getComputedStyle(message).lineHeight);
            const maxLines = 8;
            const maxHeight = lineHeight * maxLines;

            const isLong = message.scrollHeight > maxHeight + 2;

            if (!isLong) {
            card.classList.remove("is-collapsed");
            card.removeAttribute("data-entry-toggle");
            card.removeAttribute("tabindex");
            card.removeAttribute("role");
            card.removeAttribute("aria-expanded");
            card.removeAttribute("aria-controls");
            card.style.cursor = "default";
            return;
            }

            const toggle = (event) => {
            if (event && event.target && event.target.closest("a, button")) return;

            const expanded = card.getAttribute("aria-expanded") === "true";
            card.classList.toggle("is-collapsed", expanded);
            card.setAttribute("aria-expanded", expanded ? "false" : "true");
            };

            card.addEventListener("click", toggle);

            card.addEventListener("keydown", (e) => {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                toggle(e);
            }
            });
        });
    }

    if (!giftId || !token) {
        appEl.innerHTML = `
        <div class="giftletter-card">
            <p class="giftletter-error">Invalid URL.</p>
        </div>
        `;
        return;
    }

    try {
        const snap = await db.collection("giftLetters").doc(giftId).get();

        if (!snap.exists) {
        appEl.innerHTML = `
            <div class="giftletter-card">
            <p class="giftletter-error">Gift Letter not found.</p>
            </div>
        `;
        return;
        }

        const data = snap.data();

        if (!data.published || data.viewToken !== token) {
        appEl.innerHTML = `
            <div class="giftletter-card">
            <p class="giftletter-error">This Gift Letter is not available.</p>
            </div>
        `;
        return;
        }

        const coverMeta = await loadImageMeta(data.coverImageUrl);
        await preloadImage(POSTMARK_IMAGE_URL);

        const entries = (data.entries || [])
            .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))
            .map((entry, index) => `
                <div
                class="giftletter-view-entry is-collapsed"
                data-entry-toggle
                tabindex="0"
                role="button"
                aria-expanded="false"
                aria-controls="giftletter-message-${index}"
                >
                <img class="giftletter-entry-postmark" src="${POSTMARK_IMAGE_URL}" alt="">
                ${entry.name ? `<p class="giftletter-view-name">From ${escapeHtml(replaceSlackEmojiShortcodes(entry.name))}</p>` : ""}
                <div class="giftletter-view-message-wrap">
                    <p class="giftletter-view-message" id="giftletter-message-${index}">
                    ${escapeHtml(replaceSlackEmojiShortcodes(entry.message || "")).replace(/\n/g, "<br>")}
                    </p>
                </div>
                </div>
            `)
            .join("");

        appEl.innerHTML = `
        <div class="giftletter-view-wrap">
            <div class="giftletter-view-hero">
                <div class="giftletter-view-header">
                    <p class="giftletter-view-titleline">
                    <span>GIFT LETTER</span>
                    ${titleIconUrl ? `
                        <img
                        src="${titleIconUrl}"
                        alt=""
                        class="giftletter-view-titleicon"
                        >
                    ` : ""}
                    </p>
                    <h1 class="giftletter-view-title">${escapeHtml(data.title || "")}</h1>
                    ${data.subtitle ? `<p class="giftletter-view-subtitle">${escapeHtml(data.subtitle).replace(/\n/g, "<br>")}</p>` : ""}
                </div>

                ${coverMeta ? `
                <div
                    class="giftletter-view-cover"
                    style="aspect-ratio: ${coverMeta.width} / ${coverMeta.height};"
                >
                    <img
                    class="giftletter-view-cover-image"
                    src="${coverMeta.src}"
                    alt=""
                    loading="eager"
                    fetchpriority="high"
                    width="${coverMeta.width}"
                    height="${coverMeta.height}"
                    >
                    <img
                    class="giftletter-view-cover-postmark"
                    src="${POSTMARK_IMAGE_URL}"
                    alt=""
                    loading="eager"
                    >
                </div>
                ` : ""}
            </div>

            <div class="giftletter-view-list">
            ${entries}
            </div>
            <footer class="giftletter-view-footer">
                <p class="giftletter-view-footer-text">Made with GIFT LETTER by JIYUCHO<br>Inspired by hope, always.</p>
            </footer>
        </div>
        `;
        
        bindEntryToggles(appEl);
    } catch (error) {
        appEl.innerHTML = `
        <div class="giftletter-card">
            <p class="giftletter-error">${escapeHtml(error.message || "Failed to load.")}</p>
        </div>
        `;
    }
});